"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _GlacierJobParameters_1 = require("./_GlacierJobParameters");
var _SelectParameters_1 = require("./_SelectParameters");
var _OutputLocation_1 = require("./_OutputLocation");
exports._RestoreRequest = {
    type: "structure",
    required: [],
    members: {
        Days: {
            shape: {
                type: "integer"
            }
        },
        GlacierJobParameters: {
            shape: _GlacierJobParameters_1._GlacierJobParameters
        },
        Type: {
            shape: {
                type: "string"
            }
        },
        Tier: {
            shape: {
                type: "string"
            }
        },
        Description: {
            shape: {
                type: "string"
            }
        },
        SelectParameters: {
            shape: _SelectParameters_1._SelectParameters
        },
        OutputLocation: {
            shape: _OutputLocation_1._OutputLocation
        }
    }
};
//# sourceMappingURL=_RestoreRequest.js.map